var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldersBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 270,
    viewBox: "0 0 308 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_686_558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.86 74C219.7 74 234 125.448 234 168.832C234 193.151 200.873 191.835 176.86 191.835C135.723 191.835 74 210.492 74 168.832C74 113.82 122.537 74 176.86 74Z",
    fill: "url(#paint0_linear_686_558)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_686_558",
    x: 0.699997,
    y: 0.699997,
    width: 306.6,
    height: 268.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.65,
    result: "effect1_foregroundBlur_686_558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_686_558",
    x1: 154,
    y1: 74,
    x2: 154,
    y2: 196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#233584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldersBg);
export default __webpack_public_path__ + "static/media/holders-bg.112c3a635c187741341a44f8de38e1e3.svg";
export { ForwardRef as ReactComponent };